import request from '@/utils/request'

export function updateAnnouncement2Cfg(data) {
  return request({
    url: 'api/v1/announcement2/update',
    method: 'post',
    data: data
  })
}

export function AsyncAnnouncement2List(data) {
  return request({
    url: 'api/v1/announcement2/asyncOss',
    method: 'post',
    data: data
  })
}

export function getAnnouncement2List(data) {
  return request({
    url: 'api/v1/announcement2/getList',
    method: 'post',
    data: data
  })
}
export function copyAnnouncement2List(data) {
  return request({
    url: 'api/v1/announcement2/copy',
    method: 'post',
    data: data
  })
}
export function delAnnouncement2(data) {
  return request({
    url: 'api/v1/announcement2/delete',
    method: 'delete',
    data: data
  })
}

